export const getAgeOptions = new Array(120)
  .fill('')
  .map((_item, index) => ({ name: (index + 1).toString(), value: index + 1 }));
